export const TEST_ID = 'controllerList';

export const ACTIONS_COLUMN_KEY = 'actions';

export const ACTIONS_COLUMN_WIDTH = '56px';

export const MAKE_COLUMN_KEY = 'make';

export const MODEL_COLUMN_KEY = 'model';

export const NAME_COLUMN_KEY = 'nickname';

export const SERIAL_NUMBER_COLUMN_KEY = 'serialNumber';

export const EMPTY_CELL_TEXT = '—';
